import React, { useEffect, useRef } from "react";

function Star({ left, top, delay }: { left: number | string; top: number | string; delay: number | string }) {
  const starRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const size = 0.5 + Math.random() * 1.5; // 0.5-2px
    const baseOpacity = 0.1 + Math.random() * 0.9; // 10%-100%
    const duration = 1 + Math.random() * 4; // 1-5s

    if (starRef.current) {
      starRef.current.style.width = `${size}px`;
      starRef.current.style.height = `${size}px`;
      starRef.current.style.left = `${left}%`;
      starRef.current.style.top = `${top}%`;
      starRef.current.style.animationDelay = `${delay}s`;
      starRef.current.style.animationDuration = `${duration}s`;
      starRef.current.style.setProperty("--base-opacity", baseOpacity.toString());
    }
  }, [left, top, delay]);

  return <div ref={starRef} className="star-dot" />;
}

export default React.memo(Star);


